import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from "firebase/app";
import "firebase/auth";
import store from "@/store";

Vue.use(VueRouter)

const routes = [
     {
          path: '/',
          redirect: '/expo',
     },
     {
          path: '/expo',
          name: 'Expo',
          component: () => import('@/components/BabylonHome.vue'),
          meta: {
               scrollToTop: true,
          }
     },
     {
          path: '/catalog',
          name: 'Catalog',
          component: () => import('@/components/ExpoCatalog.vue'),
     },
     {
          path: '/catalog/:id/:objectId/details',
          name: 'ObjectDetails',
          component: () => import('@/components/ExpoCatalogDetails.vue'),
          meta: {
               scrollToTop: true,
          },
          props(route) {
               return {
                    object: store.getters.expoObjectById(route.params.id),
                    ...route.params,
               }
          },
     },
     {
          path: '/studio-catalog',
          name: 'StudioCatalog',
          component: () => import('@/components/ExpoStudioCatalog.vue'),
     },
     {
          path: '/studio-catalog/:id/details',
          name: 'StudioDetails',
          component: () => import('@/components/ExpoStudioCatalogDetails.vue'),
          meta: {
               scrollToTop: true,
          },
          props(route) {
               return {
                    manufacturer: store.getters.expoManufacturerById(route.params.id),
                    ...route.params,
               }
          },
     },
     {
          path: '*',
          redirect: '/expo',
     },
]

const router = new VueRouter({
     routes,
     scrollBehavior (to, from, savedPosition) {
        if (to.meta && to.meta.scrollToTop)
             return {x: 0, y: 0}
        return savedPosition
     },
     base: process.env.BASE_URL,
})

// Every visitor gets a temporary anonymous Firebase user - needed to read expo data
router.beforeEach(async (to, from, next) => {
     if (!await firebase.getCurrentUser())
          await firebase.auth().signInAnonymously();
     next();
});

router.afterEach((to, from) => {
     if ((to && to.query && to.query.lang === 'en' || to.query.lang === 'ru') &&
       router.app.$i18n.locale !== to.query.lang) {
          localStorage.setItem('lang', to.query.lang);
          router.app.$i18n.locale = to.query.lang;
     }
     //router.app.$i18n.locale = localStorage.getItem("eng");
     // 3d scene keeps globals and background loaders - always do a full page load when entering or leaving it
     if (from.name && from.name !== to.name && (from.name === "Expo" || to.name === "Expo")) {
          router.go();
     }
});
export default router
